"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  xAxisTimeFormat: {
    year: '{MMM}, {yyyy}',
    month: '{MMM} {dd}',
    day: '{MMM} {dd}'
  }
};
var _default = exports.default = locale;